/*
===============================================================================
VLETTE CAROUSEL JS
Extracted from the current baseline collection grid.
Handles card media sliders, product shelf carousels, reveal animation, sticky
style navigation.
===============================================================================
*/

(function () {
  'use strict';

  if (window.__vletteSliderInit) return;
  window.__vletteSliderInit = true;
  // Product-card image sliders
  var rafMap = new WeakMap();

  // Shared shelf carousel controls
  var productColourCarouselRafMap = new WeakMap();
  var productColourCarouselCounter = 0;
  var productColourCarouselDragState = null;
  var desktopSliderQuery = window.matchMedia('(min-width: 769px)');
  var mobileSliderQuery = window.matchMedia('(max-width: 768px)');
  // Lazy slide hydration is deliberately conservative for collection-page speed.
  var preloadObserver = null;
  var initialPreloadLimit = 3;
  var preloadRootMargin = '550px 0px';

  function runWhenIdle(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: timeout || 1200 });
      return;
    }

    window.setTimeout(callback, timeout || 350);
  }

  function getTrackWidth(track) {
    return track.clientWidth || 1;
  }

  function getSlidesCount(track) {
    return track ? track.children.length : 0;
  }

  function isMobileCardImageTrack(track) {
    if (!track || !mobileSliderQuery.matches) return false;

    var slider = track.closest ? track.closest('[data-vlette-slider]') : null;
    if (!slider) return false;

    return !!slider.closest('.grid-product--vlette-summary, .grid-product--vlette-colour-card');
  }

  function getDatasetActiveIndex(track) {
    var parsed = parseInt(track && track.dataset ? track.dataset.vletteActiveIndex : '', 10);
    return isNaN(parsed) ? 0 : parsed;
  }

  function clampTrackIndex(track, index) {
    var count = getSlidesCount(track);

    if (count <= 0) return 0;
    if (index < 0) return 0;
    if (index > count - 1) return count - 1;

    return index;
  }

  function getActiveIndex(track) {
    if (!track) return 0;

    if (isMobileCardImageTrack(track)) {
      return clampTrackIndex(track, getDatasetActiveIndex(track));
    }

    return Math.round(track.scrollLeft / getTrackWidth(track));
  }

  function hydrateLazyImage(img) {
    if (!img || img.dataset.vletteLazyHydrated === 'true') return;

    var src = img.getAttribute('data-src');
    var srcset = img.getAttribute('data-srcset');

    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-srcset');
    }

    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-src');
    }

    img.dataset.vletteLazyHydrated = 'true';
    img.removeAttribute('data-vlette-lazy-slide-image');
    img.classList.remove('is-vlette-lazy-slide');
  }

  function hydrateSlideAtIndex(track, index) {
    if (!track || index < 0) return;

    var slide = track.children[index];
    if (!slide) return;

    var images = slide.querySelectorAll('[data-vlette-lazy-slide-image]');

    for (var i = 0; i < images.length; i++) {
      hydrateLazyImage(images[i]);
    }
  }

  function hydrateAllSliderImages(track) {
    if (!track) return;

    var images = track.querySelectorAll('[data-vlette-lazy-slide-image]');

    for (var i = 0; i < images.length; i++) {
      hydrateLazyImage(images[i]);
    }
  }

  function preloadSlider(slider) {
    if (!slider || slider.dataset.vletteSlidesPreloaded === 'true') return;

    var track = slider.querySelector('[data-vlette-track]');
    if (!track) return;

    hydrateAllSliderImages(track);
    slider.dataset.vletteSlidesPreloaded = 'true';
  }

  function getPreloadObserver() {
    if (!('IntersectionObserver' in window)) return null;

    if (preloadObserver) return preloadObserver;

    preloadObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var slider = entry.target;
        preloadSlider(slider);
        preloadObserver.unobserve(slider);
      });
    }, {
      root: null,
      rootMargin: preloadRootMargin,
      threshold: 0.01
    });

    return preloadObserver;
  }

  function scheduleSliderPreload(slider) {
    if (!slider || slider.dataset.vletteSlidesPreloadObserved === 'true' || slider.dataset.vletteSlidesPreloaded === 'true') return;

    var observer = getPreloadObserver();

    if (!observer) {
      slider.dataset.vletteSlidesPreloadObserved = 'true';
      runWhenIdle(function () {
        preloadSlider(slider);
      }, 450);
      return;
    }

    slider.dataset.vletteSlidesPreloadObserved = 'true';
    observer.observe(slider);
  }

  function preloadInitialSliders(root) {
    var sliders = (root || document).querySelectorAll('[data-vlette-slider]');
    var preloaded = 0;

    runWhenIdle(function () {
      for (var i = 0; i < sliders.length; i++) {
        if (preloaded >= initialPreloadLimit) break;
        if (sliders[i].dataset.vletteSlidesPreloaded === 'true') continue;

        preloadSlider(sliders[i]);
        preloaded += 1;
      }
    }, 650);
  }

  function createSliderArrow(direction, sliderId) {
    var isPrevious = direction < 0;
    var button = document.createElement('button');

    button.className = 'vlette-arrow vlette-arrow--' + (isPrevious ? 'prev' : 'next');
    button.type = 'button';
    button.setAttribute('aria-label', isPrevious ? 'Previous image' : 'Next image');
    button.setAttribute('data-vlette-arrow', String(direction));
    button.setAttribute('aria-controls', sliderId);
    button.innerHTML = isPrevious
      ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg>';

    return button;
  }

  function getSummaryColourSwatches(card) {
    if (!card || !card.querySelectorAll) return [];

    return Array.prototype.slice.call(card.querySelectorAll('[data-vlette-summary-colour-swatch]'));
  }

  function hasMultipleSummaryColours(card) {
    return getSummaryColourSwatches(card).length > 1;
  }

  function ensureSliderArrows(slider, track, count) {
    if (!slider || !track) return;

    var card = slider.closest ? slider.closest('[data-vlette-card]') : null;
    var hasColourNavigation = hasMultipleSummaryColours(card);

    if (count <= 1 && !hasColourNavigation) return;

    var sliderId = track.getAttribute('id');
    if (!sliderId) return;

    var prev = slider.querySelector('.vlette-arrow--prev');
    var next = slider.querySelector('.vlette-arrow--next');

    if (!prev) {
      slider.insertBefore(createSliderArrow(-1, sliderId), track);
    }

    if (!next) {
      slider.insertBefore(createSliderArrow(1, sliderId), track);
    }
  }

  function setArrowDisabledState(arrow, isDisabled) {
    if (!arrow) return;

    arrow.classList.toggle('is-disabled', isDisabled);
    arrow.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    arrow.setAttribute('tabindex', isDisabled ? '-1' : '0');
  }

  function updateArrows(track, slider, count, index) {
    ensureSliderArrows(slider, track, count);

    var prev = slider.querySelector('.vlette-arrow--prev');
    var next = slider.querySelector('.vlette-arrow--next');

    if (!prev || !next) return;

    var card = slider.closest ? slider.closest('[data-vlette-card]') : null;
    var canNavigate = count > 1 || hasMultipleSummaryColours(card);

    // Summary cards can continue into the next/previous colour at an image
    // boundary, so keep the controls available even when the active colour has
    // only one image. Other cards retain the normal single-image behaviour.
    setArrowDisabledState(prev, !canNavigate);
    setArrowDisabledState(next, !canNavigate);

    prev.classList.remove('is-mobile-start-hidden');
    next.classList.remove('is-mobile-start-hidden');
  }

  function updateDots(track, slider, count, index) {
    var dotsWrap = slider.querySelector('[data-vlette-dots]');
    if (!dotsWrap) return;

    var dots = dotsWrap.querySelectorAll('[data-vlette-dot]');
    if (!dots.length) return;

    if (index < 0) index = 0;
    if (index > count - 1) index = count - 1;

    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }

  function updateUI(track) {
    if (!track) return;

    var slider = track.closest('[data-vlette-slider]');
    if (!slider) return;

    var count = getSlidesCount(track);
    var index = getActiveIndex(track);

    updateArrows(track, slider, count, index);
    updateDots(track, slider, count, index);
  }

  function requestTrackUpdate(track) {
    if (!track || rafMap.get(track)) return;

    rafMap.set(track, true);

    requestAnimationFrame(function () {
      updateUI(track);
      rafMap.set(track, false);
    });
  }

  var mobileCardTransformTransition = 'transform 260ms cubic-bezier(0.22, 1, 0.36, 1)';

  function setTrackTransform(track, value, animate) {
    if (!track) return;

    track.classList.add('is-vlette-transform-slider');
    track.style.transition = animate ? mobileCardTransformTransition : 'none';
    track.style.transform = value;
  }

  function setMobileTransformPosition(track, x, animate) {
    setTrackTransform(track, 'translate3d(' + Math.round(x) + 'px, 0, 0)', animate);
  }

  function setMobileTransformIndex(track, index, animate) {
    if (!track) return;

    index = clampTrackIndex(track, index);
    track.dataset.vletteActiveIndex = String(index);

    if (isMobileCardImageTrack(track)) {
      track.scrollLeft = 0;
      setTrackTransform(track, 'translate3d(-' + (index * 100) + '%, 0, 0)', animate);
    }

    updateUI(track);
  }

  function clearMobileTransformTrack(track) {
    if (!track || !track.classList.contains('is-vlette-transform-slider')) return;

    track.classList.remove('is-vlette-transform-slider');
    track.style.transition = '';
    track.style.transform = '';
  }

  function syncMobileTransformTrack(track, animate) {
    if (!track) return;

    if (isMobileCardImageTrack(track)) {
      setMobileTransformIndex(track, getActiveIndex(track), animate);
    } else {
      clearMobileTransformTrack(track);
    }
  }


  function clampIndex(index, count) {
    if (index < 0) return 0;
    if (index > count - 1) return count - 1;
    return index;
  }

  function isInteractiveImageControl(target) {
    return !!(target && target.closest && target.closest('[data-vlette-arrow], [data-vlette-summary-colour-swatch], .vlette-summary-product-card-quick-add, [data-vlette-collection-atc-trigger], [data-vlette-complementary-pair-trigger], [data-vlette-black-friday-info-trigger], [data-vlette-black-friday-info-area]'));
  }

  function getSummaryImageSwipeTrack(slider) {
    if (!slider) return null;
    return slider.querySelector('[data-vlette-track]');
  }

  function getOuterProductCards(track) {
    if (!track) return [];

    var cards = [];
    var children = track.children || [];

    for (var i = 0; i < children.length; i++) {
      var child = children[i];

      if (!child || !child.classList) continue;

      if (child.classList.contains('grid-product--vlette-summary') || child.classList.contains('grid-product--vlette-colour-card')) {
        cards.push(child);
      }
    }

    return cards;
  }

  function isMobileSwipeLimitedProductTrack(track) {
    if (!track) return false;

    return track.hasAttribute('data-vlette-summary-product-track') || !!track.closest('[data-vlette-style-section]');
  }

  function getActiveMobileProductCard(track) {
    if (!track || !mobileSliderQuery.matches || !isMobileSwipeLimitedProductTrack(track)) return null;

    var cards = getOuterProductCards(track);
    if (!cards.length) return null;

    // At the untouched starting position, the first card is intentionally
    // left-aligned rather than centred. It still counts as the active card.
    if (Math.abs(track.scrollLeft || 0) <= 3) {
      return cards[0];
    }

    var viewportWidth = document.documentElement.clientWidth || window.innerWidth || track.clientWidth || 1;
    var viewportCenter = viewportWidth / 2;
    var activeCard = cards[0];
    var closestDistance = Infinity;

    for (var i = 0; i < cards.length; i++) {
      var rect = cards[i].getBoundingClientRect();
      var visibleLeft = Math.max(0, rect.left);
      var visibleRight = Math.min(viewportWidth, rect.right);

      if (visibleRight <= visibleLeft) continue;

      var cardCenter = rect.left + (rect.width / 2);
      var distance = Math.abs(cardCenter - viewportCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        activeCard = cards[i];
      }
    }

    return activeCard;
  }

  function updateActiveMobileProductCard(track) {
    if (!track) return null;

    var cards = getOuterProductCards(track);
    var activeCard = mobileSliderQuery.matches ? getActiveMobileProductCard(track) : null;

    for (var i = 0; i < cards.length; i++) {
      var isActive = cards[i] === activeCard;

      cards[i].classList.toggle('is-vlette-mobile-active-card', isActive);

      if (isActive) {
        cards[i].setAttribute('data-vlette-mobile-active-card', 'true');
      } else {
        cards[i].removeAttribute('data-vlette-mobile-active-card');
      }
    }

    return activeCard;
  }

  function isActiveMobileProductCard(card) {
    if (!card || !mobileSliderQuery.matches) return true;

    var track = card.closest('[data-vlette-summary-product-track], [data-vlette-product-colour-track], [data-vlette-product-shelf-track]');
    if (!track || !isMobileSwipeLimitedProductTrack(track)) return true;

    return updateActiveMobileProductCard(track) === card;
  }

  function initMobileCardImageSwipe(slider) {
    if (!slider || slider.dataset.vletteMobileCardImageSwipeInit === 'true') return;

    var owningCard = slider.closest('.grid-product--vlette-summary, .grid-product--vlette-colour-card');
    if (!owningCard) return;

    slider.dataset.vletteMobileCardImageSwipeInit = 'true';

    var state = null;
    var clickGuardUntil = 0;
    var hasTouchEvents = ('ontouchstart' in window) || (navigator && navigator.maxTouchPoints > 0);

    function getTouchByIdentifier(touchList, identifier) {
      if (!touchList) return null;

      for (var i = 0; i < touchList.length; i++) {
        if (touchList[i].identifier === identifier) {
          return touchList[i];
        }
      }

      return null;
    }

    function getPoint(event, useChangedTouches) {
      if (!event) return null;

      if (event.touches || event.changedTouches) {
        var touch = null;

        if (state && typeof state.touchIdentifier === 'number') {
          touch = getTouchByIdentifier(useChangedTouches ? event.changedTouches : event.touches, state.touchIdentifier) ||
            getTouchByIdentifier(event.touches, state.touchIdentifier) ||
            getTouchByIdentifier(event.changedTouches, state.touchIdentifier);
        }

        if (!touch) {
          touch = (useChangedTouches && event.changedTouches && event.changedTouches[0]) ||
            (event.touches && event.touches[0]) ||
            (event.changedTouches && event.changedTouches[0]) ||
            null;
        }

        if (!touch) return null;

        return {
          clientX: touch.clientX,
          clientY: touch.clientY,
          touchIdentifier: touch.identifier
        };
      }

      if (typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return null;

      return {
        clientX: event.clientX,
        clientY: event.clientY,
        pointerId: event.pointerId
      };
    }

    function getOuterCarouselTrack() {
      return slider.closest('[data-vlette-summary-product-track], [data-vlette-product-colour-track], [data-vlette-product-shelf-track]');
    }

    function getOuterCarousel(track) {
      return track ? track.closest('.vlette-summary-carousel, .vlette-product-section-carousel') : null;
    }

    function setOuterCarouselLock(active, confirmed) {
      if (!state || !state.outerTrack) return;

      var pendingClass = 'is-vlette-card-image-swipe-pending';
      var activeClass = 'is-vlette-card-image-swipe-active';
      var outerCarousel = state.outerCarousel;
      var shouldLock = Boolean(active);
      var isConfirmed = shouldLock && Boolean(confirmed);

      state.outerTrack.classList.toggle(pendingClass, shouldLock && !isConfirmed);
      state.outerTrack.classList.toggle(activeClass, isConfirmed);

      if (outerCarousel) {
        outerCarousel.classList.toggle(pendingClass, shouldLock && !isConfirmed);
        outerCarousel.classList.toggle(activeClass, isConfirmed);
      }

      slider.classList.toggle(pendingClass, shouldLock && !isConfirmed);
      slider.classList.toggle(activeClass, isConfirmed);
      owningCard.classList.toggle(pendingClass, shouldLock && !isConfirmed);
      owningCard.classList.toggle(activeClass, isConfirmed);
    }

    function releaseOuterCarouselLock(activeState) {
      var pendingClass = 'is-vlette-card-image-swipe-pending';
      var activeClass = 'is-vlette-card-image-swipe-active';
      var track = activeState && activeState.outerTrack;
      var carousel = activeState && activeState.outerCarousel;

      if (track) {
        track.classList.remove(pendingClass, activeClass);
      }

      if (carousel) {
        carousel.classList.remove(pendingClass, activeClass);
      }

      slider.classList.remove(pendingClass, activeClass);
      owningCard.classList.remove(pendingClass, activeClass);
    }

    function keepOuterCarouselStill(activeState) {
      if (!activeState || !activeState.outerTrack) return;
      if (typeof activeState.outerStartScrollLeft !== 'number') return;

      if (Math.abs(activeState.outerTrack.scrollLeft - activeState.outerStartScrollLeft) > 1) {
        activeState.outerTrack.scrollLeft = activeState.outerStartScrollLeft;
      }
    }

    function releasePointerCapture(event) {
      if (!event || !event.type || event.type.indexOf('pointer') !== 0) return;
      if (!slider.releasePointerCapture || typeof event.pointerId !== 'number') return;

      try {
        slider.releasePointerCapture(event.pointerId);
      } catch (error) {
        // Ignore release errors after pointercancel/lostpointercapture.
      }
    }

    function shouldHandleStart(event) {
      if (!mobileSliderQuery.matches) return false;
      if (!event || isInteractiveImageControl(event.target)) return false;
      if (!isActiveMobileProductCard(owningCard)) return false;
      if (event.pointerType && event.pointerType === 'mouse') return false;
      if (hasTouchEvents && event.type && event.type.indexOf('pointer') === 0 && event.pointerType === 'touch') return false;
      if (typeof event.isPrimary === 'boolean' && !event.isPrimary) return false;
      if (event.touches && event.touches.length > 1) return false;

      var track = getSummaryImageSwipeTrack(slider);
      return !!(track && (getSlidesCount(track) > 1 || hasMultipleSummaryColours(owningCard)));
    }

    function start(event) {
      if (!shouldHandleStart(event)) return;

      var point = getPoint(event, false);
      if (!point) return;

      var track = getSummaryImageSwipeTrack(slider);
      var outerTrack = getOuterCarouselTrack();
      var startIndex = getActiveIndex(track);

      state = {
        pointerId: point.pointerId,
        touchIdentifier: point.touchIdentifier,
        track: track,
        outerTrack: outerTrack,
        outerCarousel: getOuterCarousel(outerTrack),
        outerStartScrollLeft: outerTrack ? outerTrack.scrollLeft : 0,
        startX: point.clientX,
        startY: point.clientY,
        lastX: point.clientX,
        lastY: point.clientY,
        startIndex: startIndex,
        width: getTrackWidth(track),
        count: getSlidesCount(track),
        axis: null,
        moved: false,
        startTime: Date.now()
      };

      hydrateAllSliderImages(track);
      clearHoverPreview(slider);
      setMobileTransformIndex(track, startIndex, false);
      setOuterCarouselLock(true, false);

      if (event.type && event.type.indexOf('pointer') === 0 && slider.setPointerCapture && typeof event.pointerId === 'number') {
        try {
          slider.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture is a progressive enhancement only.
        }
      }

      event.stopPropagation();
    }

    function releaseForVerticalScroll(event) {
      var activeState = state;
      state = null;

      if (activeState) {
        setMobileTransformIndex(activeState.track, activeState.startIndex, true);
        keepOuterCarouselStill(activeState);
        releaseOuterCarouselLock(activeState);
      }

      releasePointerCapture(event);
    }

    function getRubberBandedDragX(activeState, deltaX) {
      var width = activeState.width || getTrackWidth(activeState.track);
      var minX = -((activeState.count - 1) * width);
      var x = -(activeState.startIndex * width) + deltaX;

      if (x > 0) {
        x = x * 0.32;
      } else if (x < minX) {
        x = minX + ((x - minX) * 0.32);
      }

      return x;
    }

    function move(event) {
      if (!state) return;
      if (typeof state.pointerId === 'number' && typeof event.pointerId === 'number' && event.pointerId !== state.pointerId) return;

      var point = getPoint(event, false);
      if (!point) return;

      var deltaX = point.clientX - state.startX;
      var deltaY = point.clientY - state.startY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var intentThreshold = 5;

      if (!state.axis && (absX > intentThreshold || absY > intentThreshold)) {
        if (absX > absY * 1.04) {
          state.axis = 'x';
          setOuterCarouselLock(true, true);
        } else if (absY > absX * 1.04) {
          state.axis = 'y';
          releaseForVerticalScroll(event);
          return;
        }
      }

      if (state.axis !== 'x') {
        keepOuterCarouselStill(state);
        event.stopPropagation();
        return;
      }

      state.moved = true;
      state.lastX = point.clientX;
      state.lastY = point.clientY;

      if (event.cancelable !== false) {
        event.preventDefault();
      }

      event.stopPropagation();
      keepOuterCarouselStill(state);
      setMobileTransformPosition(state.track, getRubberBandedDragX(state, deltaX), false);
    }

    function end(event) {
      if (!state) return;
      if (event && typeof state.pointerId === 'number' && typeof event.pointerId === 'number' && event.pointerId !== state.pointerId) return;

      var activeState = state;
      var finalPoint = getPoint(event, true);

      state = null;
      releaseOuterCarouselLock(activeState);
      releasePointerCapture(event);

      if (activeState.axis !== 'x') {
        setMobileTransformIndex(activeState.track, activeState.startIndex, true);
        return;
      }

      if (event) {
        if (event.cancelable !== false) {
          event.preventDefault();
        }

        event.stopPropagation();
      }

      keepOuterCarouselStill(activeState);

      var endX = activeState.moved ? activeState.lastX : (finalPoint ? finalPoint.clientX : activeState.lastX);
      var deltaX = endX - activeState.startX;
      var duration = Math.max(1, Date.now() - activeState.startTime);
      var velocity = deltaX / duration;
      var threshold = Math.min(52, Math.max(20, activeState.width * 0.075));
      var nextIndex = activeState.startIndex;

      if (deltaX <= -threshold || (velocity < -0.34 && Math.abs(deltaX) > 10)) {
        nextIndex = activeState.startIndex + 1;
      } else if (deltaX >= threshold || (velocity > 0.34 && Math.abs(deltaX) > 10)) {
        nextIndex = activeState.startIndex - 1;
      }

      var crossedForwardBoundary = nextIndex > activeState.count - 1;
      var crossedBackwardBoundary = nextIndex < 0;

      if (crossedForwardBoundary && switchSummaryColourByDirection(owningCard, 1)) {
        clickGuardUntil = Date.now() + 450;
        return;
      }

      if (crossedBackwardBoundary && switchSummaryColourByDirection(owningCard, -1)) {
        clickGuardUntil = Date.now() + 450;
        return;
      }

      nextIndex = clampIndex(nextIndex, activeState.count);
      hydrateSlideAtIndex(activeState.track, nextIndex);
      setMobileTransformIndex(activeState.track, nextIndex, true);

      clickGuardUntil = Date.now() + 450;
    }

    function cancel(event) {
      if (!state) return;

      var activeState = state;
      state = null;

      setMobileTransformIndex(activeState.track, activeState.startIndex, true);
      releaseOuterCarouselLock(activeState);
      releasePointerCapture(event);
    }

    if (hasTouchEvents) {
      slider.addEventListener('touchstart', start, { capture: true, passive: false });
      slider.addEventListener('touchmove', move, { capture: true, passive: false });
      slider.addEventListener('touchend', end, { capture: true, passive: false });
      slider.addEventListener('touchcancel', cancel, { capture: true, passive: false });
    }

    if (window.PointerEvent) {
      slider.addEventListener('pointerdown', start, { capture: true, passive: false });
      slider.addEventListener('pointermove', move, { capture: true, passive: false });
      slider.addEventListener('pointerup', end, { capture: true, passive: false });
      slider.addEventListener('pointercancel', cancel, { capture: true, passive: false });
      slider.addEventListener('lostpointercapture', cancel, { capture: true, passive: false });
    }

    slider.addEventListener('click', function (event) {
      if (Date.now() > clickGuardUntil) return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }, true);
  }

  function initTrack(track) {
    if (!track || track.dataset.vletteTrackInit === 'true') return;

    track.dataset.vletteTrackInit = 'true';

    track.addEventListener('scroll', function () {
      requestTrackUpdate(track);
    }, { passive: true });

    track.addEventListener('touchstart', function () {
      hydrateAllSliderImages(track);
    }, { passive: true, once: true });

    track.addEventListener('pointerdown', function () {
      hydrateAllSliderImages(track);
    }, { passive: true, once: true });

    hydrateSlideAtIndex(track, 0);
    syncMobileTransformTrack(track, false);
    updateUI(track);

    var slider = track.closest('[data-vlette-slider]');
    if (slider) {
      enableDesktopHoverPreview(slider, track);
      initMobileCardImageSwipe(slider);
      scheduleSliderPreload(slider);
    }
  }

  function init(root) {
    var tracks = (root || document).querySelectorAll('[data-vlette-track]');

    for (var i = 0; i < tracks.length; i++) {
      initTrack(tracks[i]);
      updateUI(tracks[i]);
    }

    preloadInitialSliders(root || document);
    initProductColourCarousels(root || document);
  }

  function clearHoverPreview(slider) {
    if (!slider) return;
    delete slider.dataset.vletteHoverPreview;
  }

  function enableDesktopHoverPreview(slider, track) {
    if (!slider || !track || slider.dataset.vletteHoverPreviewInit === 'true') return;

    slider.dataset.vletteHoverPreviewInit = 'true';

    slider.addEventListener('mouseenter', function () {
      if (!desktopSliderQuery.matches) return;
      if (getSlidesCount(track) <= 1) return;

      /*
        Desktop-only hover preview:
        when the user hovers a product image from image 1,
        gently show image 2. If they then click arrows/dots,
        we stop treating it as a hover preview so controls stay intuitive.
      */
      if (getActiveIndex(track) !== 0) return;

      slider.dataset.vletteHoverPreview = 'true';
      hydrateSlideAtIndex(track, 1);
      scrollToIndex(track, 1);

      window.setTimeout(function () {
        updateUI(track);
      }, 250);
    });

    slider.addEventListener('mouseleave', function () {
      if (!desktopSliderQuery.matches) return;
      if (slider.dataset.vletteHoverPreview !== 'true') return;

      clearHoverPreview(slider);
      scrollToIndex(track, 0);

      window.setTimeout(function () {
        updateUI(track);
      }, 250);
    });
  }

  function scrollBySlide(track, direction) {
    var count = getSlidesCount(track);
    if (count <= 0) return;

    var currentIndex = getActiveIndex(track);
    var nextIndex = currentIndex + direction;
    var card = track.closest ? track.closest('[data-vlette-card]') : null;

    if (nextIndex > count - 1) {
      if (switchSummaryColourByDirection(card, 1)) return;
      nextIndex = 0;
    } else if (nextIndex < 0) {
      if (switchSummaryColourByDirection(card, -1)) return;
      nextIndex = count - 1;
    }

    if (count <= 1) return;

    hydrateSlideAtIndex(track, nextIndex);
    scrollToIndex(track, nextIndex);
  }

  function scrollToIndex(track, index) {
    hydrateSlideAtIndex(track, index);

    if (isMobileCardImageTrack(track)) {
      setMobileTransformIndex(track, index, true);
      return;
    }

    track.scrollTo({
      left: getTrackWidth(track) * index,
      behavior: 'smooth'
    });
  }

  function getImageDataForColour(card, colourHandle) {
    var dataBlocks = card.querySelectorAll('[data-vlette-colour-image-data]');

    for (var i = 0; i < dataBlocks.length; i++) {
      if (dataBlocks[i].getAttribute('data-vlette-colour-image-data') !== colourHandle) continue;

      try {
        return {
          block: dataBlocks[i],
          slides: JSON.parse(dataBlocks[i].textContent || '[]')
        };
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  function buildSrcset(slideData) {
    var parts = [];

    if (slideData.w360) parts.push(slideData.w360 + ' 360w');
    if (slideData.w540) parts.push(slideData.w540 + ' 540w');
    if (slideData.w720) parts.push(slideData.w720 + ' 720w');
    if (slideData.w900) parts.push(slideData.w900 + ' 900w');

    return parts.join(', ');
  }

  function buildPlaceholderSrc(width, height) {
    width = width || 600;
    height = height || 600;

    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 " + width + ' ' + height + "'%3E%3C/svg%3E";
  }

  function rebuildSlidesFromImageData(track, slides, url) {
    if (!track || !slides || !slides.length) return false;

    var currentFirstImage = track.querySelector('img');
    var sizes = currentFirstImage ? currentFirstImage.getAttribute('sizes') : '(min-width: 769px) 25vw, 62vw';
    var html = '';

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i] || {};
      var srcset = buildSrcset(slide);
      var height = slide.height || 600;
      var paddingBottom = slide.paddingBottom || '100%';
      var alt = slide.alt || '';
      var isFirst = i === 0;

      html += '<div class="vlette-slide" data-vlette-slide>';
      html += '<a href="' + url + '" class="vlette-slide__link" aria-label="View product">';
      html += '<div class="vlette-slide__ratio" style="padding-bottom: ' + paddingBottom + ';">';
      html += '<img class="vlette-slide__img' + (isFirst ? ' grid-product__image' : ' is-vlette-lazy-slide') + '"';

      if (isFirst) {
        html += ' src="' + (slide.src || buildPlaceholderSrc(600, height)) + '"';
        if (srcset) html += ' srcset="' + srcset + '"';
      } else {
        html += ' src="' + buildPlaceholderSrc(600, height) + '"';
        html += ' data-vlette-lazy-slide-image';
        if (slide.src) html += ' data-src="' + slide.src + '"';
        if (srcset) html += ' data-srcset="' + srcset + '"';
      }

      html += ' sizes="' + sizes + '"';
      html += ' alt="' + alt.replace(/"/g, '&quot;') + '"';
      html += ' loading="lazy" decoding="async" width="600" height="' + height + '" draggable="false"';
      html += '></div></a></div>';
    }

    track.innerHTML = html;
    return true;
  }

  function rebuildDots(slider, track) {
    var dotsWrap = slider.querySelector('[data-vlette-dots]');
    var count = getSlidesCount(track);
    var sliderId = track.getAttribute('id');

    if (!dotsWrap) {
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'vlette-dots';
      dotsWrap.setAttribute('data-vlette-dots', '');
      dotsWrap.setAttribute('aria-label', 'Carousel pagination');
      slider.appendChild(dotsWrap);
    }

    dotsWrap.innerHTML = '';

    if (count <= 1) {
      dotsWrap.style.display = 'none';
      return;
    }

    dotsWrap.style.display = '';

    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vlette-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1) + ' of ' + count);
      dot.setAttribute('aria-controls', sliderId);
      dot.setAttribute('data-vlette-dot', String(i));
      dotsWrap.appendChild(dot);
    }
  }

  function updateCardLinks(card, url) {
    if (!card || !url) return;

    card.setAttribute('data-vlette-card-url', url);

    var links = card.querySelectorAll('a.vlette-slide__link, a.grid-product__link, a.vlette-summary-product-card-title');

    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', url);
    }
  }

  function updateActiveSwatch(card, colourHandle) {
    if (!card || !colourHandle) return;

    var swatches = card.querySelectorAll('[data-vlette-summary-colour-swatch]');

    for (var i = 0; i < swatches.length; i++) {
      var isActive = swatches[i].getAttribute('data-vlette-colour-handle') === colourHandle;
      swatches[i].classList.toggle('is-active', isActive);
      swatches[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function formatSummaryColourLabel(colourName, totalColourCount) {
    var count = parseInt(totalColourCount, 10) || 0;
    var name = colourName || '';

    if (!name) {
      if (count <= 0) return '';
      return count + ' ' + (count === 1 ? 'colour' : 'colours');
    }

    if (count <= 1) {
      return name + ' only';
    }

    var otherCount = Math.max(0, count - 1);
    return name + ' + ' + otherCount + ' ' + (otherCount === 1 ? 'colour' : 'colours');
  }

  function updateSummaryCardMeta(card, swatch) {
    if (!card || !swatch) return;

    var priceTarget = card.querySelector('[data-vlette-summary-price-current], [data-vlette-summary-price-original]');
    var swatchPrice = swatch.getAttribute('data-vlette-price');

    if (priceTarget && swatchPrice) {
      priceTarget.textContent = swatchPrice;
    }

    var colourLabel = card.querySelector('[data-vlette-summary-colour-label]');

    if (colourLabel) {
      var swatchColourName = swatch.getAttribute('data-vlette-colour-name');
      var swatchColourCount = swatch.getAttribute('data-vlette-colour-count') || colourLabel.getAttribute('data-vlette-colour-count');
      var nextColourLabel = formatSummaryColourLabel(swatchColourName, swatchColourCount);

      if (nextColourLabel) {
        colourLabel.textContent = nextColourLabel;
        colourLabel.setAttribute('data-vlette-colour-count', swatchColourCount || '');
      }
    }
  }

  function getFallbackSlideFromSwatch(swatch) {
    if (!swatch) return null;

    var fallbackSrc = swatch.getAttribute('data-vlette-fallback-src') || swatch.getAttribute('data-variant-image');
    if (!fallbackSrc) return null;

    return {
      src: fallbackSrc,
      w360: swatch.getAttribute('data-vlette-fallback-w360') || fallbackSrc,
      w540: swatch.getAttribute('data-vlette-fallback-w540') || fallbackSrc,
      w720: swatch.getAttribute('data-vlette-fallback-w720') || fallbackSrc,
      w900: swatch.getAttribute('data-vlette-fallback-w900') || fallbackSrc,
      alt: swatch.getAttribute('data-vlette-fallback-alt') || swatch.getAttribute('aria-label') || '',
      height: parseInt(swatch.getAttribute('data-vlette-fallback-height'), 10) || 600,
      paddingBottom: swatch.getAttribute('data-vlette-fallback-padding-bottom') || '100%'
    };
  }

  function getActiveSummaryColourSwatch(card) {
    var swatches = getSummaryColourSwatches(card);

    for (var i = 0; i < swatches.length; i++) {
      if (swatches[i].classList.contains('is-active') || swatches[i].getAttribute('aria-pressed') === 'true') {
        return swatches[i];
      }
    }

    return swatches.length ? swatches[0] : null;
  }

  function getAdjacentSummaryColourSwatch(card, direction) {
    var swatches = getSummaryColourSwatches(card);
    if (swatches.length <= 1) return null;

    var activeSwatch = getActiveSummaryColourSwatch(card);
    var activeIndex = swatches.indexOf(activeSwatch);

    if (activeIndex < 0) activeIndex = 0;

    var nextIndex = activeIndex + (direction < 0 ? -1 : 1);

    if (nextIndex > swatches.length - 1) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = swatches.length - 1;
    }

    return swatches[nextIndex] || null;
  }

  function switchSummaryColourByDirection(card, direction) {
    if (!card || !card.classList || !card.classList.contains('grid-product--vlette-summary')) return false;

    var nextSwatch = getAdjacentSummaryColourSwatch(card, direction);
    if (!nextSwatch) return false;

    return switchCardColour(nextSwatch, {
      targetIndex: direction < 0 ? 'last' : 0
    });
  }

  function switchCardColour(swatch, options) {
    var card = swatch.closest('[data-vlette-card]');
    if (!card) return false;

    options = options || {};

    var colourHandle = swatch.getAttribute('data-vlette-colour-handle');
    var url = swatch.getAttribute('data-vlette-url');

    if (!colourHandle || !url) return false;

    updateCardLinks(card, url);
    updateActiveSwatch(card, colourHandle);
    updateSummaryCardMeta(card, swatch);

    var slider = card.querySelector('[data-vlette-slider]');
    var track = card.querySelector('[data-vlette-track]');

    if (!slider || !track) return false;

    var imageData = getImageDataForColour(card, colourHandle);
    var slides = imageData && imageData.slides && imageData.slides.length ? imageData.slides : [];

    if (!slides.length) {
      var fallbackSlide = getFallbackSlideFromSwatch(swatch);
      if (fallbackSlide) {
        slides = [fallbackSlide];
      }
    }

    if (!slides.length) return false;
    if (!rebuildSlidesFromImageData(track, slides, url)) return false;

    var targetIndex = options.targetIndex === 'last' ? slides.length - 1 : parseInt(options.targetIndex, 10);

    if (isNaN(targetIndex)) targetIndex = 0;
    targetIndex = clampIndex(targetIndex, slides.length);

    delete slider.dataset.vletteSlidesPreloaded;
    delete slider.dataset.vletteSlidesPreloadObserved;

    hydrateSlideAtIndex(track, targetIndex);
    track.dataset.vletteActiveIndex = String(targetIndex);

    if (isMobileCardImageTrack(track)) {
      setMobileTransformIndex(track, targetIndex, false);
    } else {
      clearMobileTransformTrack(track);
      track.scrollTo({ left: getTrackWidth(track) * targetIndex, behavior: 'auto' });
    }

    clearHoverPreview(slider);

    scheduleSliderPreload(slider);
    initTrack(track);

    slider.setAttribute('data-vlette-images', String(getSlidesCount(track)));

    rebuildDots(slider, track);
    updateUI(track);

    return true;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-vlette-arrow]');
    if (!arrow) return;

    event.preventDefault();
    event.stopPropagation();

    if (arrow.classList.contains('is-disabled') || arrow.getAttribute('aria-disabled') === 'true') {
      return;
    }

    var sliderId = arrow.getAttribute('aria-controls');
    var track = sliderId ? document.getElementById(sliderId) : null;
    var direction = parseInt(arrow.getAttribute('data-vlette-arrow'), 10) || 0;

    if (!track || !direction) return;

    var slider = track.closest('[data-vlette-slider]');
    clearHoverPreview(slider);

    scrollBySlide(track, direction);

    window.setTimeout(function () {
      updateUI(track);
    }, 250);
  }, true);

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('[data-vlette-dot]');
    if (!dot) return;

    event.preventDefault();
    event.stopPropagation();

    var sliderId = dot.getAttribute('aria-controls');
    var track = sliderId ? document.getElementById(sliderId) : null;
    var index = parseInt(dot.getAttribute('data-vlette-dot'), 10);

    if (!track || isNaN(index)) return;

    var slider = track.closest('[data-vlette-slider]');
    clearHoverPreview(slider);

    scrollToIndex(track, index);

    window.setTimeout(function () {
      updateUI(track);
    }, 250);
  }, true);

  function handleSummaryColourSwatchEvent(event) {
    var target = event.target;
    var swatch = target && target.closest ? target.closest('[data-vlette-summary-colour-swatch]') : null;
    if (!swatch) return;

    var card = swatch.closest ? swatch.closest('[data-vlette-card]') : null;
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    /*
      Use pointerup for mobile/touch reliability, but avoid running the same
      tap twice when the browser fires a follow-up click event. Keyboard users
      still get the click path.
    */
    if (event.type === 'click' && swatch.dataset.vletteSummarySwatchHandled === 'true') {
      swatch.dataset.vletteSummarySwatchHandled = '';
      return;
    }

    if (event.type !== 'click') {
      swatch.dataset.vletteSummarySwatchHandled = 'true';
    }

    switchCardColour(swatch);
  }

  if (window.PointerEvent) {
    document.addEventListener('pointerup', handleSummaryColourSwatchEvent, true);
  }

  document.addEventListener('click', handleSummaryColourSwatchEvent, true);

  function getProductColourCarouselGap(track) {
    if (!track || !window.getComputedStyle) return 0;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0');

    return isNaN(gap) ? 0 : gap;
  }

  function getProductColourCarouselScrollAmount(track) {
    if (!track) return 0;

    var firstCard = track.querySelector('.grid__item');
    var gap = getProductColourCarouselGap(track);

    if (firstCard) {
      return Math.max(120, Math.round(firstCard.getBoundingClientRect().width + gap));
    }

    return Math.max(120, Math.round((track.clientWidth || 0) * 0.82));
  }

  function getProductColourCarouselProgressMetrics(track, rail) {
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var railRect = rail && rail.getBoundingClientRect ? rail.getBoundingClientRect() : null;
    var railWidth = railRect && railRect.width ? railRect.width : (rail && rail.clientWidth ? rail.clientWidth : 64);
    var visibleRatio = track.clientWidth && track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
    var minimumIndicatorWidth = desktopSliderQuery.matches ? 30 : 18;
    var indicatorWidth = Math.max(minimumIndicatorWidth, Math.min(railWidth, railWidth * visibleRatio));
    var scrollProgress = maxScroll ? track.scrollLeft / maxScroll : 0;
    var maxX = Math.max(0, railWidth - indicatorWidth);
    var x = Math.max(0, Math.min(maxX, maxX * scrollProgress));

    return {
      maxScroll: maxScroll,
      railWidth: railWidth,
      indicatorWidth: indicatorWidth,
      scrollProgress: scrollProgress,
      maxX: maxX,
      x: x
    };
  }

  function scrollProductColourCarouselTo(track, left, smooth) {
    if (!track) return;

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var nextScrollLeft = Math.max(0, Math.min(maxScroll, left));
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var useSmoothScroll = smooth && !reducedMotion;

    try {
      track.scrollTo({
        left: nextScrollLeft,
        behavior: useSmoothScroll ? 'smooth' : 'auto'
      });
    } catch (error) {
      track.scrollLeft = nextScrollLeft;
    }

    requestProductColourCarouselUpdate(track);

    if (useSmoothScroll) {
      window.setTimeout(function () {
        updateProductColourCarousel(track);
      }, 260);
    } else {
      updateProductColourCarousel(track);
    }
  }

  function setProductColourCarouselFromProgressPointer(track, rail, clientX, thumbOffset, smooth) {
    if (!track || !rail) return;

    var metrics = getProductColourCarouselProgressMetrics(track, rail);
    if (!metrics.maxScroll || !metrics.maxX) return;

    var rect = rail.getBoundingClientRect();
    var offset = typeof thumbOffset === 'number' ? thumbOffset : metrics.indicatorWidth / 2;
    var targetX = clientX - rect.left - offset;
    var boundedX = Math.max(0, Math.min(metrics.maxX, targetX));
    var nextScrollLeft = (boundedX / metrics.maxX) * metrics.maxScroll;

    scrollProductColourCarouselTo(track, nextScrollLeft, Boolean(smooth));
  }

  function endProductColourCarouselProgressDrag(rail, pointerId) {
    if (!productColourCarouselDragState) return;
    if (rail && productColourCarouselDragState.rail !== rail) return;
    if (typeof pointerId === 'number' && productColourCarouselDragState.pointerId !== pointerId) return;

    var activeRail = productColourCarouselDragState.rail;

    if (activeRail) {
      activeRail.classList.remove('is-dragging');
    }

    document.documentElement.classList.remove('vlette-product-carousel-progress-is-dragging');
    productColourCarouselDragState = null;
  }

  function initProductColourCarouselProgressRail(rail, track) {
    if (!rail || !track) return;

    rail.setAttribute('aria-controls', track.id);

    if (rail.dataset.vletteProductColourProgressRailInit === 'true') return;

    rail.dataset.vletteProductColourProgressRailInit = 'true';

    if (window.PointerEvent) {
      rail.addEventListener('pointerdown', function (event) {
        if (!desktopSliderQuery.matches) return;
        if (event.button !== undefined && event.button !== 0) return;

        var indicator = rail.querySelector('[data-vlette-product-shelf-progress-indicator], [data-vlette-product-colour-carousel-progress-indicator]');
        var indicatorRect = indicator ? indicator.getBoundingClientRect() : null;
        var metrics = getProductColourCarouselProgressMetrics(track, rail);
        var isOnIndicator = indicatorRect && event.clientX >= indicatorRect.left && event.clientX <= indicatorRect.right;
        var thumbOffset = isOnIndicator ? event.clientX - indicatorRect.left : metrics.indicatorWidth / 2;

        if (!metrics.maxScroll || !metrics.maxX) return;

        if (!isOnIndicator) {
          setProductColourCarouselFromProgressPointer(track, rail, event.clientX, thumbOffset, true);
          event.preventDefault();
          return;
        }

        productColourCarouselDragState = {
          track: track,
          rail: rail,
          pointerId: event.pointerId,
          thumbOffset: thumbOffset
        };

        rail.classList.add('is-dragging');
        document.documentElement.classList.add('vlette-product-carousel-progress-is-dragging');

        if (rail.setPointerCapture) {
          try {
            rail.setPointerCapture(event.pointerId);
          } catch (error) {}
        }

        setProductColourCarouselFromProgressPointer(track, rail, event.clientX, thumbOffset, false);
        event.preventDefault();
      });

      rail.addEventListener('pointermove', function (event) {
        if (!productColourCarouselDragState) return;
        if (productColourCarouselDragState.rail !== rail) return;
        if (productColourCarouselDragState.pointerId !== event.pointerId) return;

        setProductColourCarouselFromProgressPointer(track, rail, event.clientX, productColourCarouselDragState.thumbOffset);
        event.preventDefault();
      });

      rail.addEventListener('pointerup', function (event) {
        endProductColourCarouselProgressDrag(rail, event.pointerId);
      });

      rail.addEventListener('pointercancel', function (event) {
        endProductColourCarouselProgressDrag(rail, event.pointerId);
      });

      rail.addEventListener('lostpointercapture', function (event) {
        endProductColourCarouselProgressDrag(rail, event.pointerId);
      });
    } else {
      rail.addEventListener('click', function (event) {
        if (!desktopSliderQuery.matches) return;
        setProductColourCarouselFromProgressPointer(track, rail, event.clientX, undefined, true);
      });
    }

    rail.addEventListener('keydown', function (event) {
      if (!desktopSliderQuery.matches) return;

      var key = event.key;
      var handled = true;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var left = track.scrollLeft;
      var step = getProductColourCarouselScrollAmount(track);
      var page = Math.max(step, Math.round((track.clientWidth || step) * 0.86));
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      if (key === 'ArrowLeft') {
        left -= step;
      } else if (key === 'ArrowRight') {
        left += step;
      } else if (key === 'PageUp') {
        left -= page;
      } else if (key === 'PageDown') {
        left += page;
      } else if (key === 'Home') {
        left = 0;
      } else if (key === 'End') {
        left = maxScroll;
      } else {
        handled = false;
      }

      if (!handled) return;

      event.preventDefault();

      try {
        track.scrollTo({
          left: Math.max(0, Math.min(maxScroll, left)),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      } catch (error) {
        track.scrollLeft = Math.max(0, Math.min(maxScroll, left));
      }

      requestProductColourCarouselUpdate(track);

      window.setTimeout(function () {
        updateProductColourCarousel(track);
      }, reducedMotion ? 0 : 260);
    });
  }

  function updateProductColourCarousel(track) {
    if (!track) return;

    updateActiveMobileProductCard(track);

    var carousel = track.closest('.vlette-product-section-carousel--shelf') || track.closest('.vlette-product-section-carousel--colour');
    if (!carousel) return;

    var progress = carousel.querySelector('[data-vlette-product-shelf-progress], [data-vlette-product-colour-carousel-progress]');
    var indicator = carousel.querySelector('[data-vlette-product-shelf-progress-indicator], [data-vlette-product-colour-carousel-progress-indicator]');
    var rail = carousel.querySelector('[data-vlette-product-shelf-progress-rail], [data-vlette-product-colour-carousel-progress-rail]') || (indicator ? indicator.parentElement : null);
    var previousButton = carousel.querySelector('[data-vlette-product-shelf-scroll-prev], [data-vlette-product-colour-scroll-prev]');
    var nextButton = carousel.querySelector('[data-vlette-product-shelf-scroll-next], [data-vlette-product-colour-scroll-next]');
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var hasOverflow = maxScroll > 2;
    var canScrollLeft = hasOverflow && track.scrollLeft > 2;
    var canScrollRight = hasOverflow && track.scrollLeft < maxScroll - 2;

    carousel.classList.toggle('has-overflow', hasOverflow);
    carousel.classList.toggle('can-scroll-left', canScrollLeft);
    carousel.classList.toggle('can-scroll-right', canScrollRight);

    if (previousButton) {
      previousButton.disabled = !canScrollLeft;
      previousButton.setAttribute('aria-disabled', canScrollLeft ? 'false' : 'true');
      previousButton.setAttribute('aria-hidden', hasOverflow ? 'false' : 'true');
    }

    if (nextButton) {
      nextButton.disabled = !canScrollRight;
      nextButton.setAttribute('aria-disabled', canScrollRight ? 'false' : 'true');
      nextButton.setAttribute('aria-hidden', hasOverflow ? 'false' : 'true');
    }

    if (!progress || !indicator || !rail) return;

    if (!hasOverflow) {
      progress.setAttribute('hidden', '');
      rail.tabIndex = -1;
      rail.setAttribute('aria-disabled', 'true');
      rail.setAttribute('aria-valuenow', '0');
      rail.setAttribute('aria-valuemax', '100');
      return;
    }

    progress.removeAttribute('hidden');

    var metrics = getProductColourCarouselProgressMetrics(track, rail);
    var progressValue = Math.round(metrics.scrollProgress * 100);
    var isDesktop = desktopSliderQuery.matches;

    rail.tabIndex = isDesktop ? 0 : -1;
    rail.setAttribute('aria-controls', track.id);
    rail.setAttribute('aria-disabled', isDesktop ? 'false' : 'true');
    rail.setAttribute('aria-valuemin', '0');
    rail.setAttribute('aria-valuemax', '100');
    rail.setAttribute('aria-valuenow', String(progressValue));

    indicator.style.setProperty('--vlette-colour-progress-width', metrics.indicatorWidth + 'px');
    indicator.style.setProperty('--vlette-colour-progress-x', metrics.x + 'px');
  }

  function requestProductColourCarouselUpdate(track) {
    if (!track || productColourCarouselRafMap.get(track)) return;

    productColourCarouselRafMap.set(track, true);

    requestAnimationFrame(function () {
      updateProductColourCarousel(track);
      productColourCarouselRafMap.set(track, false);
    });
  }

  function scrollProductColourCarousel(track, direction) {
    if (!track) return;

    var scrollDirection = direction < 0 ? -1 : 1;
    var amount = getProductColourCarouselScrollAmount(track) * scrollDirection;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    try {
      track.scrollBy({
        left: amount,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    } catch (error) {
      track.scrollLeft += amount;
    }

    requestProductColourCarouselUpdate(track);

    window.setTimeout(function () {
      updateProductColourCarousel(track);
    }, reducedMotion ? 0 : 260);
  }

  function initProductColourCarousels(root) {
    var tracks = (root || document).querySelectorAll('[data-vlette-product-shelf-track], [data-vlette-product-colour-track]');

    for (var i = 0; i < tracks.length; i++) {
      (function (track) {
        var carousel = track.closest('.vlette-product-section-carousel--shelf') || track.closest('.vlette-product-section-carousel--colour');
        if (!carousel) return;

        if (!track.id) {
          productColourCarouselCounter += 1;
          track.id = 'vlette-product-colour-carousel-' + productColourCarouselCounter;
        }

        var previousButton = carousel.querySelector('[data-vlette-product-shelf-scroll-prev], [data-vlette-product-colour-scroll-prev]');
        var nextButton = carousel.querySelector('[data-vlette-product-shelf-scroll-next], [data-vlette-product-colour-scroll-next]');
        var progressRail = carousel.querySelector('[data-vlette-product-shelf-progress-rail], [data-vlette-product-colour-carousel-progress-rail]');

        initProductColourCarouselProgressRail(progressRail, track);

        function initScrollButton(button, direction) {
          if (!button) return;

          button.setAttribute('aria-controls', track.id);

          if (button.dataset.vletteProductColourScrollInit === 'true') return;

          button.dataset.vletteProductColourScrollInit = 'true';
          button.addEventListener('click', function (event) {
            event.preventDefault();
            scrollProductColourCarousel(track, direction);
          });
        }

        initScrollButton(previousButton, -1);
        initScrollButton(nextButton, 1);

        if (track.dataset.vletteProductColourCarouselInit !== 'true') {
          track.dataset.vletteProductColourCarouselInit = 'true';
          track.addEventListener('scroll', function () {
            requestProductColourCarouselUpdate(track);
          }, { passive: true });
        }

        updateProductColourCarousel(track);

        window.setTimeout(function () {
          updateProductColourCarousel(track);
        }, 120);
      })(tracks[i]);
    }
  }

  function initVletteSmoothReveal(root) {
    root = root || document;

    if (!document.documentElement.classList.contains('vlette-reveal-enabled')) {
      return;
    }

    var uiItems = Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('.vlette-ui-reveal') : []);
    var cards = Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('[data-vlette-card].vlette-card-reveal') : []);

    var revealItems = uiItems.concat(cards).filter(function (item) {
      return item && item.dataset.vletteRevealDone !== 'true';
    });

    if (!revealItems.length) {
      return;
    }

    revealItems.forEach(function (item) {
      item.dataset.vletteRevealDone = 'true';
    });

    function revealAllTogether() {
      revealItems.forEach(function (item) {
        item.classList.add('is-vlette-revealed');
      });
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAllTogether();
      return;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(revealAllTogether);
    });
  }


  var vletteCardPointerState = null;
  var vletteCardIgnoreSelector = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'summary',
    '[role="button"]',
    '[role="scrollbar"]',
    '[data-vlette-summary-colour-swatch]',
    '[data-vlette-collection-atc-trigger]',
    // Sale message is a tappable information area: never follow the card URL.
    '[data-vlette-black-friday-info-trigger]',
    '[data-vlette-black-friday-info-area]',
    '[data-vlette-dot]',
    '[data-vlette-arrow]',
    '[data-vlette-product-shelf-progress]',
    '[data-vlette-product-shelf-progress-rail]',
    '[data-vlette-product-shelf-scroll-prev]',
    '[data-vlette-product-shelf-scroll-next]'
  ].join(',');

  document.addEventListener('pointerdown', function (event) {
    var target = event.target;
    var card = target && target.closest ? target.closest('[data-vlette-card][data-vlette-card-url]') : null;

    if (!card) {
      vletteCardPointerState = null;
      return;
    }

    var track = card.closest('[data-vlette-product-shelf-track], [data-vlette-summary-product-track], [data-vlette-product-colour-track]');

    vletteCardPointerState = {
      card: card,
      x: event.clientX,
      y: event.clientY,
      scrollLeft: track ? track.scrollLeft : 0,
      track: track
    };
  }, true);

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = event.target;
    var card = target && target.closest ? target.closest('[data-vlette-card][data-vlette-card-url]') : null;

    if (!card) return;
    if (target.closest && target.closest(vletteCardIgnoreSelector)) return;

    if (vletteCardPointerState && vletteCardPointerState.card === card) {
      var dx = Math.abs((event.clientX || 0) - vletteCardPointerState.x);
      var dy = Math.abs((event.clientY || 0) - vletteCardPointerState.y);
      var scrolled = vletteCardPointerState.track ? Math.abs(vletteCardPointerState.track.scrollLeft - vletteCardPointerState.scrollLeft) : 0;

      if (dx > 8 || dy > 8 || scrolled > 4) return;
    }

    var url = card.getAttribute('data-vlette-card-url');

    if (!url || url === '#') return;

    window.location.href = url;
  }, false);

  initVletteSmoothReveal(document);

  function syncAllMobileImageTracks(root, animate) {
    var tracks = (root || document).querySelectorAll('[data-vlette-track]');

    for (var i = 0; i < tracks.length; i++) {
      syncMobileTransformTrack(tracks[i], animate);
      updateUI(tracks[i]);
    }
  }

  window.addEventListener('resize', function () {
      initProductColourCarousels(document);
      syncAllMobileImageTracks(document, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      initVletteSmoothReveal(document);
    });
  } else {
    init(document);
    initVletteSmoothReveal(document);
  }

  if (desktopSliderQuery.addEventListener) {
    desktopSliderQuery.addEventListener('change', function () {
      init(document);
      syncAllMobileImageTracks(document, false);
      initVletteSmoothReveal(document);
    });
  }

  if (mobileSliderQuery.addEventListener) {
    mobileSliderQuery.addEventListener('change', function () {
      syncAllMobileImageTracks(document, false);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
    initVletteSmoothReveal(event.target || document);
  });
})();

(function () {
  'use strict';

  if (window.__vletteStyleScrollspyInit) return;
  window.__vletteStyleScrollspyInit = true;

  var root = document.documentElement;
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var nav = null;
  var scroller = null;
  var tabs = [];
  var sections = [];
  var activeId = '';
  var scrollTicking = false;
  var resizeTimer = null;
  var stickyHeaderCandidates = null;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getStickyHeaderCandidates() {
    if (stickyHeaderCandidates) return stickyHeaderCandidates;

    var selectors = [
      '[data-vlette-sticky-header="true"]',
      '#shopify-section-header',
      '#SiteHeader',
      '#HeaderWrapper',
      '.header-sticky-wrapper',
      '.site-header',
      '.site-header-wrapper',
      '.header-wrapper',
      '[data-section-type="header"]',
      'header[role="banner"]'
    ];

    stickyHeaderCandidates = selectors
      .map(function (selector) {
        return document.querySelector(selector);
      })
      .filter(function (element, index, list) {
        return element && list.indexOf(element) === index;
      });

    return stickyHeaderCandidates;
  }

  function getStickyHeaderHeight() {
    var height = 0;

    getStickyHeaderCandidates().forEach(function (element) {
      if (!element) return;

      var rect = element.getBoundingClientRect();
      if (!rect || rect.height <= 0 || rect.width <= 0) return;

      var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
      var position = style ? style.position : '';
      var isHidden = style && (style.display === 'none' || style.visibility === 'hidden');
      var isStickyLike = position === 'fixed' || position === 'sticky' || rect.top <= 1;

      if (!isHidden && isStickyLike && rect.bottom > 0 && rect.height > height) {
        height = rect.height;
      }
    });

    return Math.round(height);
  }

  function getNavHeight() {
    return nav && !nav.hidden ? Math.round(nav.getBoundingClientRect().height || nav.offsetHeight || 0) : 0;
  }

  function updateOffsets() {
    var headerHeight = getStickyHeaderHeight();
    var navHeight = getNavHeight();

    root.style.setProperty('--vlette-style-scrollspy-top', headerHeight + 'px');
    root.style.setProperty('--vlette-style-scrollspy-height', navHeight + 'px');

    return {
      header: headerHeight,
      nav: navHeight
    };
  }

  function elementLooksVisible(element) {
    if (!element) return false;

    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;

    var rect = element.getBoundingClientRect ? element.getBoundingClientRect() : null;
    return !!rect && rect.width > 0 && rect.height > 0;
  }

  function isSiteMenuOpen() {
    if (!mobileQuery.matches) return false;

    var classText = ((document.documentElement && document.documentElement.className) || '') + ' ' + ((document.body && document.body.className) || '');

    if (/\b(js-drawer-open|js-drawer-open-left|js-drawer-open-right|drawer-open|mobile-nav-open|menu-open|nav-open)\b/.test(classText)) {
      return true;
    }

    var openDrawerSelectors = [
      '#NavDrawer.is-open',
      '#NavDrawer.drawer--is-open',
      '#NavDrawer[aria-hidden="false"]',
      '#MobileNav.is-open',
      '#MobileNav[aria-hidden="false"]',
      '#MobileNavDrawer.is-open',
      '#MobileNavDrawer[aria-hidden="false"]',
      '.drawer.is-open',
      '.drawer--is-open',
      '.mobile-nav-wrapper.is-open',
      '.mobile-nav.is-open',
      '.site-nav--mobile.is-open',
      '[data-drawer].is-open',
      '[data-drawer][aria-hidden="false"]',
      '[id*="Drawer"][aria-hidden="false"]',
      '[id*="drawer"][aria-hidden="false"]',
      '[id*="MobileNav"][aria-hidden="false"]'
    ];

    for (var i = 0; i < openDrawerSelectors.length; i++) {
      var drawer = document.querySelector(openDrawerSelectors[i]);
      if (elementLooksVisible(drawer)) {
        return true;
      }
    }

    return false;
  }

  function updateSiteMenuOpenState() {
    root.classList.toggle('vlette-site-menu-is-open', isSiteMenuOpen());
  }

  function updateStickyVisualState(offsets) {
    if (!nav) return;

    updateSiteMenuOpenState();

    offsets = offsets || updateOffsets();

    var rect = nav.getBoundingClientRect();
    var stickyTop = offsets.header + 1;
    var isStuck = rect.top <= stickyTop && rect.bottom > stickyTop;

    nav.classList.toggle('is-stuck', isStuck);
  }

  function refreshElements() {
    nav = document.querySelector('[data-vlette-style-scrollspy]');
    scroller = nav ? nav.querySelector('[data-vlette-style-scrollspy-scroller]') : null;
    tabs = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-vlette-style-scrollspy-tab]')) : [];
    sections = [];

    if (!nav || !scroller || tabs.length <= 1) {
      if (nav) nav.hidden = true;
      return false;
    }

    tabs.forEach(function (tab) {
      var id = tab.getAttribute('data-vlette-style-target') || (tab.getAttribute('href') || '').replace('#', '');
      var section = id ? document.getElementById(id) : null;

      if (!section) return;

      tab.setAttribute('aria-controls', id);
      sections.push({
        id: id,
        tab: tab,
        section: section
      });
    });

    nav.hidden = sections.length <= 1;
    activeId = '';
    updateScrollspyOverflowState();

    return sections.length > 1;
  }

  function updateScrollspyOverflowState() {
    if (!scroller) return;

    var maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    var currentLeft = Math.max(0, scroller.scrollLeft || 0);
    var hasOverflow = maxLeft > 2;

    scroller.classList.toggle('has-horizontal-overflow', hasOverflow);
    scroller.classList.toggle('can-scroll-left', hasOverflow && currentLeft > 2);
    scroller.classList.toggle('can-scroll-right', hasOverflow && currentLeft < maxLeft - 2);
  }

  function scrollTabIntoView(tab, behavior) {
    if (!scroller || !tab) return;

    var targetLeft = tab.offsetLeft - ((scroller.clientWidth - tab.offsetWidth) / 2);
    var maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    var nextLeft = Math.max(0, Math.min(maxLeft, targetLeft));

    scroller.scrollTo({
      left: nextLeft,
      behavior: behavior || 'smooth'
    });

    window.setTimeout(updateScrollspyOverflowState, 180);
  }

  function setActive(id, shouldCenterTab) {
    if (!id || id === activeId) return;

    activeId = id;

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-vlette-style-target') === id;
      tab.classList.toggle('is-active', isActive);

      if (isActive) {
        tab.setAttribute('aria-current', 'true');
        if (shouldCenterTab) {
          scrollTabIntoView(tab, prefersReducedMotion() ? 'auto' : 'smooth');
        }
      } else {
        tab.removeAttribute('aria-current');
      }
    });

    updateScrollspyOverflowState();
  }

  function updateActiveFromScroll() {
    scrollTicking = false;

    if (!nav || !document.body.contains(nav) || !sections.length) {
      if (!refreshElements()) return;
    }

    var offsets = updateOffsets();
    updateStickyVisualState(offsets);

    /*
      Use viewport coordinates instead of offsetTop. The style catalogue can sit
      inside full-bleed/padded wrappers, where offsetTop may be relative to an
      intermediate ancestor rather than the document. getBoundingClientRect()
      keeps the active tab aligned to the section currently under the sticky nav.
    */
    var referenceViewportY = offsets.header + offsets.nav + Math.min(140, Math.round(window.innerHeight * 0.18));
    var next = sections[0];

    for (var i = 0; i < sections.length; i++) {
      var section = sections[i].section;
      if (!section || !document.body.contains(section)) continue;

      var rect = section.getBoundingClientRect();
      if (!rect || rect.height <= 0) continue;

      if (rect.top <= referenceViewportY) {
        next = sections[i];
      } else {
        break;
      }
    }

    if (next) {
      setActive(next.id, true);
    }
  }

  function requestActiveUpdate() {
    if (scrollTicking) return;

    scrollTicking = true;
    window.requestAnimationFrame(updateActiveFromScroll);
  }

  function scrollToSection(section) {
    if (!section) return;

    var offsets = updateOffsets();
    var extraBreathingRoom = 18;
    var targetTop = section.getBoundingClientRect().top + window.pageYOffset - offsets.header - offsets.nav - extraBreathingRoom;

    window.scrollTo({
      top: Math.max(0, Math.round(targetTop)),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function handleTabClick(event) {
    var tab = event.target.closest ? event.target.closest('[data-vlette-style-scrollspy-tab]') : null;
    if (!tab) return;

    var id = tab.getAttribute('data-vlette-style-target');
    var section = id ? document.getElementById(id) : null;
    if (!section) return;

    event.preventDefault();

    setActive(id, true);
    scrollToSection(section);
  }

  function init() {
    stickyHeaderCandidates = null;

    if (!refreshElements()) return false;

    updateStickyVisualState(updateOffsets());
    updateScrollspyOverflowState();
    updateActiveFromScroll();

    return true;
  }

  function rehydrateStyleScrollspy() {
    updateSiteMenuOpenState();

    if (init()) {
      requestActiveUpdate();
    }

    window.setTimeout(function () {
      updateSiteMenuOpenState();
      if (init()) {
        requestActiveUpdate();
      }
    }, 80);

    window.setTimeout(function () {
      updateSiteMenuOpenState();
      if (init()) {
        requestActiveUpdate();
      }
    }, 260);
  }

  document.addEventListener('click', handleTabClick, true);
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-vlette-style-scrollspy]')) return;

    window.setTimeout(updateSiteMenuOpenState, 0);
    window.setTimeout(updateSiteMenuOpenState, 220);
  }, true);

  if (window.MutationObserver) {
    var menuStateObserver = new MutationObserver(function () {
      updateSiteMenuOpenState();
    });

    menuStateObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    if (document.body) {
      menuStateObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  window.addEventListener('scroll', requestActiveUpdate, { passive: true });
  window.addEventListener('load', init);

  document.addEventListener('scroll', function (event) {
    if (scroller && event.target === scroller) {
      updateScrollspyOverflowState();
    }
  }, true);

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      init();
      updateScrollspyOverflowState();
      requestActiveUpdate();
    }, 90);
  });

  window.addEventListener('pageshow', function () {
    rehydrateStyleScrollspy();
  });

  window.addEventListener('popstate', function () {
    rehydrateStyleScrollspy();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      rehydrateStyleScrollspy();
    }
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', function () {
      init();
      requestActiveUpdate();
    });
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(rehydrateStyleScrollspy, 60);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
